export enum Nationality {
  Afghan = 'Afghan',
  Albanian = 'Albanian',
  Algerian = 'Algerian',
  American = 'American',
  Andorran = 'Andorran',
  Angolan = 'Angolan',
  AntiguanOrBarbudan = 'Antiguan or Barbudan',
  Argentine = 'Argentine',
  Armenian = 'Armenian',
  Australian = 'Australian',
  Austrian = 'Austrian',
  Azerbaijani = 'Azerbaijani',
  Bahamian = 'Bahamian',
  Bahraini = 'Bahraini',
  Bangladeshi = 'Bangladeshi',
  Barbadian = 'Barbadian',
  Belarusian = 'Belarusian',
  Belgian = 'Belgian',
  Belizean = 'Belizean',
  Beninese = 'Beninese',
  Bhutanese = 'Bhutanese',
  Bolivian = 'Bolivian',
  BosnianOrHerzegovinian = 'Bosnian or Herzegovinian',
  Botswanan = 'Botswanan',
  Brazilian = 'Brazilian',
  British = 'British',
  Bruneian = 'Bruneian',
  Bulgarian = 'Bulgarian',
  Burkinabe = 'Burkinabe',
  Burmese = 'Burmese',
  Burundian = 'Burundian',
  CaboVerdean = 'Cabo Verdean',
  Cambodian = 'Cambodian',
  Cameroonian = 'Cameroonian',
  Canadian = 'Canadian',
  CentralAfrican = 'Central African',
  Chadian = 'Chadian',
  Chilean = 'Chilean',
  Chinese = 'Chinese',
  Colombian = 'Colombian',
  Comorian = 'Comorian',
  Congolese = 'Congolese',
  CostaRican = 'Costa Rican',
  Croatian = 'Croatian',
  Cuban = 'Cuban',
  Cypriot = 'Cypriot',
  Czech = 'Czech',
  Danish = 'Danish',
  Djiboutian = 'Djiboutian',
  Dominican = 'Dominican',
  DominicanRepublic = 'Dominican Republic',
  EastTimorese = 'East Timorese',
  Ecuadorean = 'Ecuadorean',
  Egyptian = 'Egyptian',
  ElSalvadoran = 'El Salvadoran',
  EquatorialGuinean = 'Equatorial Guinean',
  Eritrean = 'Eritrean',
  Estonian = 'Estonian',
  Eswatini = 'Eswatini',
  Ethiopian = 'Ethiopian',
  Fijian = 'Fijian',
  Finnish = 'Finnish',
  French = 'French',
  Gabonese = 'Gabonese',
  Gambian = 'Gambian',
  Georgian = 'Georgian',
  German = 'German',
  Ghanaian = 'Ghanaian',
  Greek = 'Greek',
  Grenadian = 'Grenadian',
  Guatemalan = 'Guatemalan',
  Guinean = 'Guinean',
  GuineaBissauan = 'Guinea Bissauan',
  Guyanese = 'Guyanese',
  Haitian = 'Haitian',
  Honduran = 'Honduran',
  Hungarian = 'Hungarian',
  Icelander = 'Icelander',
  Indian = 'Indian',
  Indonesian = 'Indonesian',
  Iranian = 'Iranian',
  Iraqi = 'Iraqi',
  Irish = 'Irish',
  Italian = 'Italian',
  Ivorian = 'Ivorian',
  Jamaican = 'Jamaican',
  Japanese = 'Japanese',
  Jordanian = 'Jordanian',
  Kazakh = 'Kazakh',
  Kenyan = 'Kenyan',
  Kiribati = 'Kiribati',
  Korean = 'Korean',
  Kuwaiti = 'Kuwaiti',
  Kyrgyz = 'Kyrgyz',
  Laotian = 'Laotian',
  Latvian = 'Latvian',
  Lebanese = 'Lebanese',
  Lesotho = 'Lesotho',
  Liberian = 'Liberian',
  Libyan = 'Libyan',
  Liechtenstein = 'Liechtenstein',
  Lithuanian = 'Lithuanian',
  Luxembourgish = 'Luxembourgish',
  Macedonian = 'Macedonian',
  Malagasy = 'Malagasy',
  Malawian = 'Malawian',
  Malaysian = 'Malaysian',
  Maldivian = 'Maldivian',
  Malian = 'Malian',
  Maltese = 'Maltese',
  Marshallese = 'Marshallese',
  Mauritian = 'Mauritian',
  Mauritanian = 'Mauritanian',
  Mexican = 'Mexican',
  Micronesian = 'Micronesian',
  Moldovan = 'Moldovan',
  Monegasque = 'Monegasque',
  Mongolian = 'Mongolian',
  Montserratian = 'Montserratian',
  Moroccan = 'Moroccan',
  Mozambican = 'Mozambican',
  Namibian = 'Namibian',
  Nauruan = 'Nauruan',
  Nepalese = 'Nepalese',
  NewZealander = 'New Zealander',
  Nicaraguan = 'Nicaraguan',
  Nigerian = 'Nigerian',
  Niuean = 'Niuean',
  NorthKorean = 'North Korean',
  Norwegian = 'Norwegian',
  Omani = 'Omani',
  Pakistani = 'Pakistani',
  Palauan = 'Palauan',
  Panamanian = 'Panamanian',
  PapuaNewGuinean = 'Papua New Guinean',
  Paraguayan = 'Paraguayan',
  Palestinian = 'Palestinian',
  Peruvian = 'Peruvian',
  Philippine = 'Philippine',
  Polish = 'Polish',
  Portuguese = 'Portuguese',
  Qatari = 'Qatari',
  Romanian = 'Romanian',
  Russian = 'Russian',
  Rwandan = 'Rwandan',
  SaintLucian = 'Saint Lucian',
  Salvadoran = 'Salvadoran',
  Samoan = 'Samoan',
  SanMarinese = 'San Marinese',
  SaoTomean = 'Sao Tomean',
  Saudi = 'Saudi',
  Senegalese = 'Senegalese',
  Serbian = 'Serbian',
  Seychellois = 'Seychellois',
  SierraLeonean = 'Sierra Leonean',
  Singaporean = 'Singaporean',
  Slovak = 'Slovak',
  Slovenian = 'Slovenian',
  SolomonIsland = 'Solomon Island',
  Somali = 'Somali',
  SouthAfrican = 'South African',
  SouthKorean = 'South Korean',
  Spanish = 'Spanish',
  SriLankan = 'Sri Lankan',
  Sudanese = 'Sudanese',
  Surinamese = 'Surinamese',
  Swazi = 'Swazi',
  Swedish = 'Swedish',
  Swiss = 'Swiss',
  Syrian = 'Syrian',
  Taiwanese = 'Taiwanese',
  Tajik = 'Tajik',
  Tanzanian = 'Tanzanian',
  Thai = 'Thai',
  Togolese = 'Togolese',
  Tongan = 'Tongan',
  Trinidadian = 'Trinidadian',
  Tunisian = 'Tunisian',
  Turkish = 'Turkish',
  Turkmen = 'Turkmen',
  Tuvaluan = 'Tuvaluan',
  Ugandan = 'Ugandan',
  Ukrainian = 'Ukrainian',
  Uruguayan = 'Uruguayan',
  Uzbek = 'Uzbek',
  Vanuatuan = 'Vanuatuan',
  Venezuelan = 'Venezuelan',
  Vietnamese = 'Vietnamese',
  Yemeni = 'Yemeni',
  Zambian = 'Zambian',
  Zimbabwean = 'Zimbabwean',
}
